export function getMonsterShortName(name?: string | null, shortName?: string | null) {
	if (shortName) return shortName;
	if (!name) return '';

	const base = name.split(',')[0];
	let out = base.replace(
		/(?:adult|ancient|young|взрослый|древний|молодой) \w+ (dragon|dracolich|дракон|драколич)/gi,
		'$1',
	);
	return out.toLowerCase();
}
